import { type CommentResponse, toComment } from 'src/models/apis/comment/commentResponse';

export type AdminCommentResponse = CommentResponse;

export type AdminCommentIndexResponse = CommentResponse[];

export const toAdminComment = toComment;
